import { useEffect } from 'react';

export default function Contact() {
  useEffect(() => {
    const w = 'https://tally.so/widgets/embed.js';
    const v = () => {
      if (typeof (window as any).Tally !== 'undefined') {
        (window as any).Tally.loadEmbeds();
      } else {
        document.querySelectorAll<HTMLIFrameElement>('iframe[data-tally-src]:not([src])').forEach((e) => {
          e.src = e.dataset.tallySrc || '';
        });
      }
    };

    if (typeof (window as any).Tally !== 'undefined') {
      v();
    } else if (!document.querySelector(`script[src="${w}"]`)) {
      const s = document.createElement('script');
      s.src = w;
      s.onload = v;
      s.onerror = v;
      document.body.appendChild(s);
    } else {
      v();
    }
  }, []);

  return (
    <section id="contacto" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Contacto
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Hablemos de tus <span className="text-teal-600">Necesidades</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Déjanos tus datos y te contactaremos para revisar tus necesidades operacionales y HSE.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Tally embed */}
          <div>
            <iframe
              data-tally-src="https://tally.so/embed/ZjR50y?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1&hideDescription=1"
              loading="lazy"
              width="100%"
              height="200"
              frameBorder={0}
              marginHeight={0}
              marginWidth={0}
              title="Contáctanos"
            ></iframe>
          </div>

          {/* Info lateral */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-6">Información de Contacto</h3>

              <div className="space-y-5">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl sm:text-2xl"></i>
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="text-sm text-white/80 mb-1">Email</div>
                    <a
                      href="mailto:operaciones@safelinesolutions.net"
                      className="text-sm sm:text-base font-semibold hover:text-white/90 transition-colors break-all rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                    >
                      operaciones@safelinesolutions.net
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-xl sm:text-2xl"></i>
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="text-sm text-white/80 mb-1">Sitio Web</div>
                    <a
                      href="https://www.safelinesolutions.net"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-base sm:text-lg font-semibold hover:text-white/90 transition-colors break-all rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                    >
                      www.safelinesolutions.net
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4">¿Por qué contactarnos?</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm text-gray-700">Respuesta en menos de 24 horas</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm text-gray-700">Evaluación inicial sin costo</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm text-gray-700">Propuestas personalizadas</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm text-gray-700">Asesoría de expertos con experiencia real</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
